import { create } from 'zustand'

import { BillingContact } from '__generated__/atlas-types'

// Setters
type SetHandler = (
  handler: (
    state: BillingContactState,
  ) => BillingContactState | Partial<BillingContactState>,
) => void

type SetBillingContacts = (
  billingContacts: BillingContact[],
  set?: SetHandler,
) => void
const setBillingContacts: SetBillingContacts = (billingContacts, set) =>
  set && set(() => ({ billingContacts }))

type SetBillingContactAtIndex = (
  index: number,
  contact: BillingContact,
  set?: SetHandler,
) => void
const setBillingContactAtIndex: SetBillingContactAtIndex = (
  index,
  contact,
  set,
) =>
  set &&
  set((state) => {
    if (!state.billingContacts[index]) {
      return {}
    }

    const newContacts = [...state.billingContacts]
    newContacts[index] = contact
    return { billingContacts: newContacts }
  })

type RemoveBillingContactAtIndex = (index: number, set?: SetHandler) => void
const removeBillingContactAtIndex: RemoveBillingContactAtIndex = (index, set) =>
  set &&
  set((state) => {
    if (!state.billingContacts[index]) {
      return {}
    }

    const newContacts = [...state.billingContacts]
    newContacts.splice(index, 1)
    return { billingContacts: newContacts }
  })

type SetIsLoading = (isLoading: boolean, set?: SetHandler) => void
const setIsLoading: SetIsLoading = (isLoading, set) =>
  set && set(() => ({ isLoading }))

// Store
const initialData = {
  billingContacts: [],
  isLoading: false,
}

interface BillingContactState {
  billingContacts: BillingContact[]
  isLoading: boolean
  setBillingContacts: SetBillingContacts
  setBillingContactAtIndex: SetBillingContactAtIndex
  removeBillingContactAtIndex: RemoveBillingContactAtIndex
  setIsLoading: SetIsLoading
  resetStore: () => void
}

export default create<BillingContactState>((set) => ({
  ...initialData,
  setBillingContacts: (billingContacts) =>
    setBillingContacts(billingContacts, set),
  setBillingContactAtIndex: (index, contact) =>
    setBillingContactAtIndex(index, contact, set),
  removeBillingContactAtIndex: (index) =>
    removeBillingContactAtIndex(index, set),
  setIsLoading: (isLoading) => setIsLoading(isLoading, set),
  resetStore: () => set && set(initialData),
}))
